import AsoHeader from '../../../components/Aso/Header';
import AsoValidarIdentidade from '../../../components/Aso/Register/AsoValidarIdentidade';

const AsoRegistroValidarIdentidade: React.FC = () => {

  return (
    <div>
      <AsoHeader />
      <AsoValidarIdentidade />
    </div>
  );
}

export default AsoRegistroValidarIdentidade;